<template>
  <section class="banner-area">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-7">
          <div class="main-ban-heading">
            <h1>Welcome to the GCIC<br />Investor Directory!</h1>
            <p>
              We are focused on helping entrepreneurs in Ghana’s Green<br />
              Economy to find investors that are a good match for their
              <br />business.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Banner"
};
</script>



// WEBPACK FOOTER //
// src/elements/Banner.vue